export const TARGET_ID_COMMUNITY = '#portal-c24-travel-community';
